'use client'

import { useContext } from 'react'

import { UnreadMessagesContext } from '../../contexts/UnreadMessagesProvider'
import { UnreadMessagesContextValue } from '../../types/unread-messages'

const useUnreadMessagesContext = (): UnreadMessagesContextValue => {
  const context = useContext(UnreadMessagesContext)

  if (!context) {
    throw new Error('useUnreadMessagesContext must be used within UnreadMessagesProvider')
  }

  return context
}

export default useUnreadMessagesContext
